export default {
    init() {
        /* Global Util: Modal Behavior */

        const modalClosed = function () {
            if ('createEvent' in document) {
                const event = new CustomEvent('modal-closed');
                document.dispatchEvent(event);
            }
        };

        /* Move all modals to just inside the body tag */
        const modals = document.querySelectorAll('.modal');
        modals.forEach((item) => {
            document.querySelector('body').appendChild(item);
        });

        /* Open modal based on href target */
        const modal = document.querySelectorAll('[data-ispot=modal]');
        modal.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                document.getElementById(e.currentTarget.hash.substring(1)).classList.add('show');
            });
        });

        /* Close on click of modal dismiss button */
        const dismissModal = document.querySelectorAll('[data-dismiss=modal]');
        dismissModal.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const closestModal = e.currentTarget.closest('.modal.show');
                if (closestModal !== null) {
                    closestModal.classList.remove('show');
                }
                modalClosed();
            });
            // item.addEventListener('modal-closed', (e) => {
            //     console.log('OOF2');
            // });
        });

        /* Close on click of modal background */
        const openModal = document.querySelectorAll('.modal');
        openModal.forEach((item) => {
            item.addEventListener('click', (e) => {
                if (e.target.classList.contains('show')) {
                    e.target.classList.remove('show');
                    modalClosed();
                }
            });
        });
    },
};
